<template>
  <b-section-loader :loading="$loading.isLoading('getDocType')">
    <v-card border>
      <v-card-text>
        <b-form hide-action-buttons @submit="updateDocType">
          <div class="d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-file-document-outline" size="23"></v-icon>
              </div>

              <div>
                <div class="font-weight-bold font-size-18">
                  {{ docTypeSource.name }}
                </div>
                <div class="d-flex ga-2">
                  <v-chip
                    color="grey"
                    density="compact"
                    rounded="lg"
                    size="small">
                    <span
                      class="font-size-10 font-weight-bold text-grey-darken-2">
                      {{ docTypeSource.code }}
                    </span>
                  </v-chip>

                  <div class="text-disabled">Журнал реєстрації</div>
                </div>
              </div>
            </div>
            <div class="d-flex align-center ga-3">
              <v-chip
                v-if="docTypeSource.isActive"
                color="success"
                @click="docTypeToggleActive">
                <b>Активний</b>
              </v-chip>
              <v-chip
                v-if="!docTypeSource.isActive"
                color="error"
                @click="docTypeToggleActive">
                <b>Неактивний</b>
              </v-chip>

              <v-btn
                v-show="docTypeCredentials.$hasChanges"
                :loading="$loading.isLoading('docTypeDefinitionUpdate')"
                type="submit">
                <v-icon class="mr-1" color="white">mdi-check</v-icon>
                Зберегти
              </v-btn>
            </div>
          </div>

          <v-divider class="mt-5 mb-4"></v-divider>

          <v-tabs class="mb-5" color="primary" slider-color="blue-darken-3">
            <v-tab :to="{ name: 'doc-type-definition-general-info' }" replace>
              Основне
            </v-tab>
            <v-tab :to="{ name: 'doc-type-definition-fields' }" replace>
              Конструктор
            </v-tab>
            <v-tab :to="{ name: 'doc-type-definition-routes' }" replace>
              Маршрути
            </v-tab>
            <v-tab :to="{ name: 'doc-type-definition-actions' }" replace>
              Дії
            </v-tab>
            <v-tab :to="{ name: 'doc-type-definition-accesses' }" replace>
              Доступи
            </v-tab>
          </v-tabs>

          <router-view></router-view>
        </b-form>
      </v-card-text>
    </v-card>
  </b-section-loader>
</template>

<script lang="ts" setup>
import { initDocType } from './docType'
import { BForm, BSectionLoader } from 'best-modules/components'

defineOptions({
  name: 'DocTypeSingle',
})

const {
  docTypeSource,
  docTypeCredentials,
  updateDocType,
  docTypeToggleActive,
} = initDocType()
</script>

<style lang="scss" scoped>
.icon--blue {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #e6f1fb;

  .v-icon {
    color: #185fa5;
  }
}
</style>
